import { memo, SyntheticEvent, useCallback } from 'react'
import { Button as ButtonBase, IButtonProps as IButtonBaseProps } from 'components/ui/Button'

type TSize = Required<IButtonBaseProps>['size']

export const BUTTON_SIZE: Record<TSize, TSize> = {
  xs: 'xs',
  sm: 'sm',
  nm: 'nm',
  lg: 'lg',
  xl: 'xl'
} as const

type TAppearance = Required<IButtonBaseProps>['appearance']

export const BUTTON_APPEARANCE: Record<TAppearance, TAppearance> = {
  info: 'info',
  primary: 'primary',
  success: 'success',
  secondary: 'secondary',
  transparent: 'transparent',
  danger: 'danger'
} as const

type TContentPosition = Required<IButtonBaseProps>['contentPosition']

export const BUTTON_CONTENT_POSITION: Record<TContentPosition, TContentPosition> = {
  start: 'start',
  center: 'center',
  end: 'end'
} as const

export interface IButtonProps extends IButtonBaseProps {}

export const Button = memo(function Button({ children, onClick, testId, ...rest }: IButtonProps) {
  const handleClick = useCallback(
    (e: SyntheticEvent<HTMLButtonElement, Event>) => {
      onClick && onClick(e)
    },
    [onClick]
  )

  return (
    <ButtonBase onClick={handleClick} testId={testId} {...rest}>
      {children}
    </ButtonBase>
  )
})
